import {Link, Stack, Text, TooltipHost, useTheme} from '@fluentui/react';
import {DateTimeFormat, formatDateTime} from 'i18n/localeDateFormat';
import React from 'react';
import i18n from 'i18n/i18n';
import {getListClassNames} from 'styles';
import {useTranslation} from 'react-i18next';

export const useVkoApproverWorkbenchUtils = () => {
	const theme = useTheme();
	const classNames = getListClassNames(theme, true);
	const {t} = useTranslation('features/dashboard', {
		keyPrefix: 'VkoParagraphsWorkbenchItems',
	});

	const renderRegulatoryDocumentColumnField = (item: any): JSX.Element => {
		const rejectReason =
			(item?.workflow?.message?.length || 0) > 16 ? (
				<TooltipHost content={item.workflow.message}>
					<div>
						{`${t('RejectReason')} ${item.workflow.message.substring(
							0,
							15,
						)}...`}
					</div>
				</TooltipHost>
			) : (
				<div>
					`${t('RejectReason')} ${item.workflow.message}`
				</div>
			);
		return (
			<div className={classNames.itemContent}>
				<Stack horizontal horizontalAlign={'space-between'}>
					<Stack>
						<Text>{item.regulation.regulationNumber}</Text>
						<Link to={`/regulatoryDocuments/${item.id}`}>
							<div className={classNames.itemName}>{item.name}</div>
						</Link>
					</Stack>
				</Stack>
				<div className={classNames.itemSubtext}>
					{formatDateTime(
						new Date(item.createdAt),
						i18n,
						DateTimeFormat.DateMonthWeekday,
					)}
				</div>
				{item.workflow.message && rejectReason}
			</div>
		);
	};

	const sortAndHideByCreationDate = (
		inputData: any[],
		isAscending: boolean,
		isHidden: (item: any) => boolean,
		hiddenExpanded: boolean,
	) => {
		let shown: any[] = [];
		let hidden: any[] = [];
		if (inputData.length === 0) {
			return [];
		}
		inputData.forEach(rd => {
			if (rd.type !== 'Separator') {
				if (isHidden(rd.id)) {
					hidden.push(rd);
				} else {
					shown.push(rd);
				}
			}
		});
		if (isAscending) {
			shown = shown.sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1));
			hidden = hidden.sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1));
		} else {
			shown = shown.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1));
			hidden = hidden.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1));
		}
		return hiddenExpanded
			? shown.concat([{type: 'Separator'}]).concat(hidden)
			: shown.concat([{type: 'Separator'}]);
	};

	const sortByCreationDate = (inputData: any[], isAscending: boolean) => {
		if (inputData.length === 0) {
			return [];
		}
		if (isAscending) {
			return inputData.sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1));
		}
		return inputData.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1));
	};

	return {
		renderRegulatoryDocumentColumnField,
		sortAndHideByCreationDate,
		sortByCreationDate,
	};
};
